export enum TwrxErrorCode {
	UnhandledError = 1,
	FileIsTooLarge = 2,
	BadRequest = 3,
	InvalidFileType = 4,
	FileExpired = 5,
	FileNotFound = 6,
	ValidationFailed = 7,
	InvalidUsernameOrPassword = 101,
	UserIsDisabled = 104,
	LinkExpired = 106,
	AuthenticationRequired = 107,
	AccessCodeExpired = 109,
	PasswordContainPersonalInformation = 110,
	WeakPasswordPattern = 111,
	MaxInvalidLoginAttempts = 112,
	PasswordReuse = 113,
	PasswordResetRequired = 114,
	InvalidApplicationAccessKey = 115,
	PasswordAlreadyChangedRecently = 201,
	UserAlreadyExists = 202,
	UserNotFound = 203,
	RoleNotFound = 401,
	RoleAlreadyExists = 402,
	CustomerNotFound = 501,
	CustomerRetentionRateNotFound = 502,
	CustomerRetentionRateRageInterception = 503,
	CustomerNoteNotFound = 504,
	CustomerCustomDateOfServiceNotFound = 505,
	CustomerDateOfServiceSubmissionPeriodAlreadyInUse = 506,
	CustomerCustomDateOfServiceAlreadyExists = 507,
	CustomerAlreadyExists = 508,
	CustomerRebateAggregatorAttributeValueNotFound = 509,
	CustomerRebateAggregatorAttributeValueAlreadyExists = 510,
	CustomerTechEnablementFeeNotFound = 511,
	CustomerTechEnablementFeeRangeInterception = 512,
	GeneratedFileNotFound = 601,
	BulkOperationOverloaded = 701,
	RebatesLoadFileNotFound = 1101,
	RebatesLoadTemplateNotFound = 1102,
	RebatesLoadFileStatisticNotFound = 1103,
	RebatesLoadSheetNotFound = 1104,
	InvalidQuantityName = 1105,
	RebateLoadConversionTypeNotFound = 1106,
	RebateRecordNotFound = 1107,
	DontHavePermissionToDeleteFile = 1108,
	CantDeleteSubmittedFile = 1109,
	InvalidFileDuplicateJson = 1110,
	CantDeleteLastDuplicateInGroup = 1111,
	RebatesLoadFileMappingNotFound = 1112,
	RebatesLoadFileAlreadyLoaded = 1113,
	NotValidSubmissionPeriodStatus = 1114,
	RebatesLoadFileNotReadyForAggregation = 1115,
	RebateAggregatorNotFound = 1201,
	RebateAggregatorNdcEffectiveDateInvalid = 1202,
	RebateAggregatorAlreadyExist = 1204,
	RebateNotFound = 1301,
	ReportNotFound = 1401,
	InvalidReportType = 1402,
	RebatesReSubmissionFileNotFound = 1601,
	UserDoesntHaveTenants = 2001,
	ClaimFileNotFound = 2002,
	ClaimFileDeleted = 2003,
	InvalidIngredientsCount = 2004,
	FacilityNotFound = 2101,
	FacilityMappingNotFound = 2102,
	NoFacilitiesAtImportedFile = 2103,
	LocationImportNameColumnNotExist = 2104,
	LocationImportTypeColumnNotExist = 2105,
	LocationImportEffectiveDateColumnNotExist = 2106,
	LocationImportHierarchy3ColumnNotExist = 2107,
	SubmissionPeriodStartColumnNotExist = 2108,
	FacilityMappingAlreadyMapped = 2109,
	FacilityMappingCannotBeDeleted = 2110,
	FacilityMappingToFileNotFound = 2111,
	LocationCannotBeDeleted = 2112,
	LineOfBusinessNotFound = 2201,
	LineOfBusinessAlreadyExist = 2202,
	LineOfBusinessSubtypeNotFound = 2301,
	LineOfBusinessSubtypeAlreadyExist = 2302,
	BdcNotFound = 2401,
	BdcAlreadyExist = 2402,
	CustomerBdcNotFound = 2501,
	NdcReplacementMappingNotFound = 2601,
	NdcReplacementMappingAlreadyExistsForPeriodsRange = 2602,
	NdcReplacementMappingInvalidPeriodsRange = 2603,
	DownstreamClientIdAssociationNotFound = 2701,
	DownstreamClientIdAssociationAlreadyExists = 2703,
	SubmissionPeriodNotFound = 2801,
	SubmissionPeriodDatesOverlap = 2802,
	SubmissionPeriodAlreadyExist = 2803,
	CannotDeleteSubmissionPeriodStatistic = 2861,
	CannotDeleteSubmissionPeriodRebateLoad = 2862,
	CannotDeleteSubmissionPeriodCustomer = 2863,
	CannotDeleteSubmissionPeriodLocation = 2864,
	CannotDeleteSubmissionPeriodEligibleNdc = 2865,
	CannotDeleteSubmissionPeriodNdcReplacement = 2866,
	CannotDeleteSubmissionPeriodCustomerBdc = 2867,
	RebateAggregatorNdcRateNotFound = 2901,
	RebateAggregatorNdcRateNdcColumnNotExist = 2902,
	RebateAggregatorNdcRateColumnNotExist = 2903,
	RebateAggregatorNdcRateFillDateStartColumnNotExist = 2904,
	RebateAggregatorNdcRateEffectiveDateStartColumnNotExist = 2905,
	RebateAggregatorNdcRateAggregatorColumnNotExist = 2906,
	RebateAggregatorNdcRateAggregatorFormularyColumnNotExist = 2907,
	AberrantQuantityNotFound = 3001,
	AberrantQuantityNdcAlreadyExist = 3002,
	UnbreakableQuantityNotFound = 3101,
	UnbreakableQuantityNdcAlreadyExist = 3102,
	PharmacyProviderNcpdpNotFound = 3201,
	PharmacyIdReviewNotFound = 3202,
	PharmacyIdReviewRejectNotAllowed = 3203,
	RebateGroupNotFound = 3301,
	RebateGroupNameAlreadyExist = 3302,
	RebateGroupRebateAggregatorAttributeValueNotFound = 3303,
	RebateGroupRebateAggregatorAttributeValueAlreadyExists = 3304,
	RebateGroupCannotBeDeleted = 3305,
	ExternalApplicationAlreadyExists = 3401,
	ExternalApplicationNotFound = 3402,
	ExcludedPharmacyNotFound = 3501,
	ExcludedPharmacyNcpdpAlreadyExist = 3502,
	RebateAggregatorFormularyNotFound = 3601,
	RebateAggregatorFormularyAlreadyExist = 3602,
	RebateAggregatorAttributeNotFound = 3603,
	RebateAggregatorAttributeAlreadyExist = 3604,
	RebateAggregatorAttributeCannotBeDeleted = 3605,
	FormularyNdcNotFound = 3701,
	FormularyNdcColumnNotExist = 3702,
	FormularyNdcFillDateStartColumnNotExist = 3703,
	FormularyNdcEffectiveDateStartColumnNotExist = 3704,
	FormularyNdcAggregatorColumnNotExist = 3705,
	FormularyNdcAggregatorFormularyColumnNotExist = 3706,
	FormularyNdcAlreadyExist = 3707,
	InOutpatientDefinitionNotFound = 3801,
	NonPatientExclusionNotFound = 3901,
	NonPatientExclusionAlreadyExist = 3902,
	AutoProcessingConfigNotFound = 4001,
	CustomerRebateGroupNotFound = 4101,
	CustomerRebateOverlap = 4102,
	RebateGroupAggregatorNdcNotFound = 4201,
	CustomerAccessGroupNotFound = 4301,
	NoAccessibleCustomers = 4302,
	NoAccessibleRebateAggregators = 4303,
	CustomerNdcDestinationNotFound = 4401,
	SubmissionTaskNotFound = 4501,
	SubmissionTaskCommentNotFound = 4502,
	SubmissionTaskInvalidCustomerSubmissionAction = 4503,
	/**
	 * The comment image does not exist or its comment is deleted.
	 */
	SubmissionTaskCommentAttachmentNotFound = 4504,
	/**
	 * An uploaded comment image is not a PNG/JPEG within the size and dimension limits, the uploaded images don't match the content's local: keys one to one, or the
	 * content refers to an image the comment does not have.
	 */
	SubmissionTaskCommentInvalidAttachment = 4505,
	/**
	 * The comment content has more image lines than allowed.
	 */
	SubmissionTaskCommentAttachmentsLimitExceeded = 4506,
	NoNdcsAtImportedFile = 4601,
	NdcDestinationImportActionColumnNotExist = 4602,
	NdcDestinationImportNdcColumnNotExist = 4603,
	NdcDestinationImportRebateGroupColumnNotExist = 4604,
	NdcDestinationImportRebateAggregatorColumnNotExist = 4605,
	NdcDestinationImportEffectiveDateColumnNotExist = 4606,
	NdcDestinationImportTerminationDateColumnNotExist = 4607,
	NdcDestinationImportNdcNotFound = 4608,
	NdcDestinationImportFileNotFound = 4609,
	NdcDestinationImportFileCannotBeRemoved = 4610,
	RebateSubmissionFileGenerationNotSupported = 4701,
	RebateSubmissionFileAlreadyGenerating = 4702,
	RebateSubmissionFileNotFound = 4703,
	RebateSubmissionFileNotGenerated = 4704,
	RebateSubmissionFileSubmissionNotSupported = 4705,
	RebateSubmissionFileAlreadySubmitted = 4706,
	RebateSubmissionFileDebugFileInvalid = 4707,
	RebateSubmissionFileNotSubmitted = 4708,
	RebateSubmissionFileAlreadyFinalized = 4709,
	RebateSubmissionFileNotEncrypted = 4710,
	/**
	 * The lookup job does not exist or belongs to another user.
	 */
	RawDataLookupJobNotFound = 4801,
	/**
	 * The user already has the maximum number of active (queued, fetching or building) lookup jobs.
	 */
	RawDataLookupTooManyActiveJobs = 4802,
	/**
	 * The job's current status does not allow the requested action.
	 */
	RawDataLookupInvalidState = 4803,
	/**
	 * The job has no built result file to download.
	 */
	RawDataLookupResultNotAvailable = 4804,
	/**
	 * The chosen Unique Transaction ID column is not a header of the uploaded file.
	 */
	RawDataLookupUtidColumnNotFound = 4805,
	/**
	 * A column or rule refers to a header key that none of the job's source files has.
	 */
	RawDataLookupUnknownHeaderKey = 4806
}
